import {notice} from "/assets/js/utils/notices";
import {nsFetch} from "/assets/js/utils/fetch";

const MOBILE_BREAKPOINT = 768;

class Account {
    mainContainer;
    userBlock;
    aside;
    asideNav;
    repeatBtns;
    repeatOrderBtn;
    headerCart;

    constructor(elm) {
        this.mainContainer = elm;
        this.userBlock = this.mainContainer.querySelector('.account-page__aside-user');
        this.aside = this.mainContainer.querySelector('.account-page__aside');
        this.asideNav = this.aside.querySelector('.account-page__aside-nav');
        this.navLinks = this.asideNav.querySelectorAll('.account-page__aside-nav-link');
        this.repeatBtns = this.mainContainer.querySelectorAll('.button-repeat-order');
        this.repeatOrderBtn = this.mainContainer.querySelectorAll('.button-repeat-order');
        this.headerCart = document.querySelector('.header__actions-cart');

        this.init();
        this.initMobileNav();
    }

    init() {
        this.repeatBtns.forEach(elm => elm.addEventListener('click', this._clickRepeatOrder));
    }

    _clickRepeatOrder = async (e) => {
        e.preventDefault();
        const btn = e.target.closest('.button-repeat-order');

        btn.classList.add('is-loading');

        const data = {
            'order_id': btn.dataset.orderId,
        };

        const response = await nsFetch.doFetch({
            action: 'ns_repeat_order',
            body: data
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
        } else {
            notice(
                response.data.message,
                'success'
            );

            if (response.data.total_count > 99) {
                this.headerCart.dataset.cartCount = '99+';
                this.headerCart.classList.add('nine-nine-plus');
            } else {
                this.headerCart.dataset.cartCount = response.data.total_count;
                this.headerCart.classList.remove('nine-nine-plus');
            }
        }

        btn.classList.remove('is-loading');
    }

    isMobile() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    closeNav = () => {
        if (!this.isMobile()) return;
        this.aside.classList.remove('active');
    }

    toggleNav = () => {
        if (!this.isMobile()) return;
        this.aside.classList.toggle('active');
    }

    initMobileNav() {
        if (!this.userBlock || !this.aside) return;

        // Открытие/закрытие меню при клике на блок пользователя
        this.userBlock.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleNav();
        });

        if (this.navLinks) {
            this.navLinks.forEach(link => {
                link.addEventListener('click', this.closeNav);
            });
        }
       

        // Закрытие меню при клике вне его
        document.addEventListener('click', (e) => {
            if (!this.isMobile()) return;

            // Если клик был вне aside блока, закрываем меню
            if (!this.aside.contains(e.target)) {
                this.closeNav();
            }
        });

        // Закрытие меню при изменении размера окна (если перешли на десктоп)
        window.addEventListener('resize', () => {
            if (!this.isMobile()) {
                this.closeNav();
            }
        });
    }

    
}


document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.account-page');
    if (elm) {
        new Account(elm);
    }
});



